import React from 'react';

type WaitingProps = {
  title?: string | React.ReactNode;
};

const Waiting: React.FC<WaitingProps> = ({ title }: WaitingProps) => {
  return (
    <div className="text-center">
      {title && <div>{title}</div>}
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            margin: 'auto',
            background: 'none',
            display: 'block',
            shapeRendering: 'auto',
          }}
          width="120px"
          height="120px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <title>Waiting</title>
          <path
            className="checkout-panel-icon-color"
            d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              dur="1s"
              from="0 50 50"
              to="360 50 50"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
    </div>
  );
};

export default Waiting;
